// Pieces the finance modals share: the drawer while its data loads or why it could not, and a notice for a step that no
// longer applies. Flat rows on gray, no nested cards (DD-002).
import { ReactNode } from "react";
import { ENTITY_CONFIG } from "@/core/entityConfig";
import { ModalPending } from "../components/ModalPending";
import { FinanceDrawer, type FinanceDrawerSize } from "../components/FinanceDrawer";
import type { PairedData } from "../utils/pairedData";

const clientWord = ENTITY_CONFIG.client.label.toLowerCase();

const JOB_MISSING = { title: "Job not found", message: `This job no longer exists. The ${clientWord}'s current jobs are on the Money tab.` };

/**
 * The drawer while its data loads, why it could not, or that what the link points at is gone (a 404). Job drawers
 * use the default notice, the person drawers pass their own. `size` is the width of the drawer it stands in for.
 */
export function JobPending({
  title,
  data,
  onClose,
  missing = JOB_MISSING,
  size,
}: {
  title: string;
  data: Pick<PairedData<unknown, unknown>, "load" | "failure" | "retrying" | "retry">;
  onClose: () => void;
  missing?: { title: string; message: string };
  size?: FinanceDrawerSize;
}) {
  if (data.load === "missing") {
    return <StaticNotice title={missing.title} message={missing.message} onClose={onClose} size={size} />;
  }
  return <ModalPending title={title} failure={data.load === "failed" ? data.failure : null} retrying={data.retrying} retry={data.retry} onClose={onClose} size={size} />;
}

/** A step that no longer applies, for a stale or hand-typed link. */
export function StaticNotice({ title, message, onClose, size }: { title: string; message: ReactNode; onClose: () => void; size?: FinanceDrawerSize }) {
  return (
    <FinanceDrawer onClose={onClose} size={size} title={title}>
      <p className="text-sm text-gray-600">{message}</p>
    </FinanceDrawer>
  );
}
